import { AnnotationTriageAreaId } from '@admin-panel/annotation-triage/area-id'
import { ApPricingAreaId } from '@admin-panel/ap-pricing/area-id'
import { ApServiceSettingsAreaId as AdminPanelServiceSettingsAreaId } from '@admin-panel/ap-service-settings/area-id'
import { DisengagementVoicebotAreaId } from '@admin-panel/disengagement-voicebot/area-id'
import { EvaluationAiAreaId } from '@admin-panel/evaluation-ai/area-id'
import { GlobalVehicleManagementAreaId } from '@admin-panel/global-vehicle-management/area-id'
import { HulkTripsAreaId } from '@admin-panel/hulk-trips/area-id'
import { IncidentAnalysisAreaId } from '@admin-panel/incident-analysis/area-id'
import { RouteBuilderAreaId } from '@admin-panel/route-builder/area-id'
import { TemporaryBackofficeSessionsAreaId } from '@admin-panel/temporary-backoffice-sessions/area-id'
import { TripHistoryAreaId } from '@admin-panel/trip-history/area-id'
import { UserManagementAreaId } from '@admin-panel/user-management/area-id'
import { VehicleMonitoringAreaId } from '@admin-panel/vehicle-monitoring/area-id'
import { VirtualTestingAreaId } from '@admin-panel/virtual-testing/area-id'
import { FleetDashboardAreaId } from '@backoffice/fleet-dashboard/area-id'
import { FleetTracingRedirectAreaId } from '@backoffice/fleet-tracing-redirect/area-id'
import { InAppMessagesAreaId } from '@backoffice/in-app-messages/area-id'
import { RemoteAssistanceOperatorAreaId } from '@backoffice/remote-assistance-operator/area-id'
import { RiderFeedbackAreaId } from '@backoffice/rider-feedback/area-id'
import { RiderSupportAreaId } from '@backoffice/rider-support/area-id'
import { RoadNetworkAreaId } from '@backoffice/road-network/area-id'
import { TracingAreaId } from '@backoffice/tracing/area-id'
import { TripApiConfigurationAreaId } from '@backoffice/trip-api-configuration/area-id'
import { UserManagementOrganizationAreaId } from '@backoffice/user-management-organization/area-id'
import { VehicleCapacityConfigAreaId } from '@backoffice/vehicle-capacity-config/area-id'
import { AlertsAreaId } from '@backoffice-frontend/alerts/area-id'
import { AlertsCommonAreaId } from '@backoffice-frontend/alerts-common/area-id'
import { AlertsTestingAreaId } from '@backoffice-frontend/alerts-testing/area-id'
import { AppAccessControlAreaId } from '@backoffice-frontend/app-access-control/area-id'
import { CapacityPlanningAreaId } from '@backoffice-frontend/capacity-planning/area-id'
import {
  AccidentsReportsAreaId,
  AccountingAreaId,
  AdConfigurationAreaId,
  AdFleetMapAreaId,
  CouponAreaId,
  CustomerAreaId,
  CustomerFeatureAllowlistingAreaId,
  DisruptionsAreaId,
  DsBossAreaId,
  FleetMapAreaId,
  LegalDocumentManagementAreaId,
  PatternLibraryAreaId,
  SafetyDriverGuidanceAreaId,
  ScLabsAreaId,
  VirtualAdVehiclesAreaId,
} from '@backoffice-frontend/common'
import { DemoRoutesAreaId } from '@backoffice-frontend/demo-routes/area-id'
import { DriverTippingAreaId } from '@backoffice-frontend/driver-tipping/area-id'
import { EmployeeAreaId } from '@backoffice-frontend/employee/area-id'
import { EmployeeTimeManagementAreaId } from '@backoffice-frontend/employee-time-management/area-id'
import { FleetMaintenanceAreaId } from '@backoffice-frontend/fleet-maintenance/area-id'
import { FleetManagementTestingAreaId } from '@backoffice-frontend/fleet-management-testing/area-id'
import { FleetPerformanceOverviewAreaId } from '@backoffice-frontend/fleet-performance-overview/area-id'
import { FleetsAreaId } from '@backoffice-frontend/fleets/area-id'
import { KpiDashboardAreaId } from '@backoffice-frontend/kpi-dashboard/area-id'
import { MobileAppFlavorConfigAreaId } from '@backoffice-frontend/mobile-app-flavor-config/area-id'
import { MobileAppstoreAssetsAreaId } from '@backoffice-frontend/mobile-appstore-assets/area-id'
import { OfferAndPoolingAreaId } from '@backoffice-frontend/offer-and-pooling/area-id'
import { PassengerAppAreaId } from '@backoffice-frontend/passenger-app/area-id'
import { PricingAreaId } from '@backoffice-frontend/pricing/area-id'
import { StopNetworkAreaId } from '@backoffice-frontend/sam-common/stop-network-area-id'
import { ServiceBreakLocationsAreaId } from '@backoffice-frontend/service-break-locations/area-id'
import { ServiceSettingsAreaId } from '@backoffice-frontend/service-settings/area-id'
import { ShiftsAreaId } from '@backoffice-frontend/shifts/area-id'
import { ShiftsCreationAreaId } from '@backoffice-frontend/shifts-creation/area-id'
import { TripAreaId } from '@backoffice-frontend/trip/area-id'
import { VehicleAreaId } from '@backoffice-frontend/vehicle/area-id'
import { VehicleAlertsAreaId } from '@backoffice-frontend/vehicle-alerts/area-id'
import { UpdatesAreaId } from '@shared/updates/area-id'
import { useTranslation } from 'react-i18next'

const HubsAreaId = 'hubs' as const

export const useGetAreaTranslation = () => {
  const { t } = useTranslation()

  const getAreaTranslation = (id: string) => {
    switch (id) {
      case UserManagementAreaId:
        return t('authenticatedAppView_userManagementArea')
      case IncidentAnalysisAreaId:
        return t('authenticatedAppView_incidentAnalysisArea')
      case UserManagementOrganizationAreaId:
        return t('authenticatedAppView_userManagementArea')
      case AlertsAreaId:
        return t('authenticatedAppView_alertsArea')
      case CapacityPlanningAreaId:
        return t('authenticatedAppView_capacityPlanningArea')
      case EmployeeAreaId:
        return t('authenticatedAppView_employeeArea')
      case ShiftsAreaId:
        return t('authenticatedAppView_shiftsArea')
      case DriverTippingAreaId:
        return t('authenticatedAppView_driverTippingArea')
      case EmployeeTimeManagementAreaId:
        return t('authenticatedAppView_employeeTimeManagementArea')
      case VehicleAlertsAreaId:
        return t('authenticatedAppView_vehicleAlertsArea')
      case FleetMaintenanceAreaId:
        return t('authenticatedAppView_fleetMaintenanceArea')
      case VehicleAreaId:
        return t('authenticatedAppView_vehicleArea')
      case FleetMapAreaId:
        return t('authenticatedAppView_fleetMapArea')
      case AdFleetMapAreaId:
        return t('authenticatedAppView_adFleetMapArea')
      case RemoteAssistanceOperatorAreaId:
        return t('authenticatedAppView_controlCenterArea')
      case StopNetworkAreaId:
        return t('authenticatedAppView_stopNetworkArea')
      case HubsAreaId:
        return t('authenticatedAppView_hubsArea')
      case CustomerAreaId:
        return t('authenticatedAppView_customerArea')
      case TripAreaId:
        return t('authenticatedAppView_tripArea')
      case DisengagementVoicebotAreaId:
        return t('authenticatedAppView_disengagementVoicebotArea')
      case EvaluationAiAreaId:
        return t('authenticatedAppView_evaluationAIArea')
      case CouponAreaId:
        return t('authenticatedAppView_couponArea')
      case AdConfigurationAreaId:
        return t('authenticatedAppView_adConfigurationArea')
      case AccountingAreaId:
        return t('authenticatedAppView_accountingArea')
      case PassengerAppAreaId:
        return t('authenticatedAppView_passengerAppArea')
      case PricingAreaId:
        return t('authenticatedAppView_pricingArea')
      case AlertsTestingAreaId:
        return t('authenticatedAppView_alertsTestingArea')
      case PatternLibraryAreaId:
        return t('authenticatedAppView_patternLibraryArea')
      case ShiftsCreationAreaId:
        return t('authenticatedAppView_shiftsCreationArea')
      case FleetManagementTestingAreaId:
        return t('authenticatedAppView_fleetManagementTestingArea')
      case VirtualAdVehiclesAreaId:
        return t('authenticatedAppView_virtualAdVehiclesArea')
      case DsBossAreaId:
        return t('authenticatedAppView_dsBossArea')
      case CustomerFeatureAllowlistingAreaId:
        return t('authenticatedAppView_customerFeatureAllowlistingArea')
      case AccidentsReportsAreaId:
        return t('authenticatedAppView_accidentsReportsArea')
      case SafetyDriverGuidanceAreaId:
        return t('authenticatedAppView_safetyDriverGuidanceArea')
      case DisruptionsAreaId:
        return t('authenticatedAppView_disruptionsArea')
      case FleetsAreaId:
        return t('authenticatedAppView_fleetsArea')
      case FleetDashboardAreaId:
        return t('authenticatedAppView_fleetDashboardArea')
      case OfferAndPoolingAreaId:
        return t('authenticatedAppView_offerAndPoolingArea')
      case ServiceSettingsAreaId:
        return t('authenticatedAppView_serviceSettingsArea')
      case LegalDocumentManagementAreaId:
        return t('authenticatedAppView_legalDocumentManagementArea')
      case FleetTracingRedirectAreaId:
        return t('authenticatedAppView_fleetTracingArea')
      case TracingAreaId:
        return t('authenticatedAppView_tracingArea')
      case FleetPerformanceOverviewAreaId:
        return t('authenticatedAppView_fleetPerformanceOverviewArea')
      case MobileAppstoreAssetsAreaId:
        return t('authenticatedAppView_mobileAppstoreAssetsArea')
      case RoadNetworkAreaId:
        return t('authenticatedAppView_roadNetworkArea')
      case AppAccessControlAreaId:
        return t('authenticatedAppView_appAccessControlArea')
      case DemoRoutesAreaId:
        return t('authenticatedAppView_demoRoutesArea')
      case RiderFeedbackAreaId:
        return t('authenticatedAppView_riderFeedbackArea')
      case RiderSupportAreaId:
        return t('authenticatedAppView_riderSupportArea')
      case ServiceBreakLocationsAreaId:
        return t('authenticatedAppView_serviceBreakLocationsArea')
      case KpiDashboardAreaId:
        return t('authenticatedAppView_serviceKpisSection_navigation')
      case ScLabsAreaId:
        return t('authenticatedAppView_scLabsSection_navigation')
      case AlertsCommonAreaId:
        return t('authenticatedAppView_hscAlerts_navigation')
      case MobileAppFlavorConfigAreaId:
        return t('authenticatedAppView_mobileAppFlavorConfigArea')
      case InAppMessagesAreaId:
        return t('authenticatedAppView_inAppMessagesArea')
      case VehicleCapacityConfigAreaId:
        return t('authenticatedAppView_vehicleCapacityConfigArea')
      case TripApiConfigurationAreaId:
        return t('authenticatedAppView_tripApiConfigurationArea')
      case VirtualTestingAreaId:
        return t('authenticatedAppView_virtualTestingArea')
      case AdminPanelServiceSettingsAreaId:
        return t('authenticatedAppView_serviceSettingsArea')
      case ApPricingAreaId:
        return t('authenticatedAppView_pricingArea')
      case TemporaryBackofficeSessionsAreaId:
        return t('authenticatedAppView_temporaryBackofficeSessionsArea')
      case RouteBuilderAreaId:
        return t('authenticatedAppView_routeBuilderArea')
      case AnnotationTriageAreaId:
        return t('authenticatedAppView_annotationTriageArea')
      case TripHistoryAreaId:
        return t('authenticatedAppView_tripHistoryArea')
      case VehicleMonitoringAreaId:
        return t('authenticatedAppView_vehicleMonitoringArea')
      case HulkTripsAreaId:
        return t('authenticatedAppView_hulkTripsArea')
      case UpdatesAreaId:
        return t('authenticatedAppView_updatesArea')
      case GlobalVehicleManagementAreaId:
        return t('authenticatedAppView_globalVehicleManagementArea')
      default:
        return id
    }
  }

  return { getAreaTranslation }
}
